// ------------------------------------------------------------------------------ //
// Slick jquery
// ------------------------------------------------------------------------------ //


import "slick-carousel/slick/slick.min";
